import { app } from '../common/api/apiClient'
import { AccountType, type InitKYC as InitKYC_T, KYCStatus as KYCStatusT } from '@/common/types'
import { API_ROUTES } from '@/common/constants'
import { insertStringVariables } from '@/common/utils/utils'
import { KycProviders } from './types'

export async function initKYC(data: { provider: KycProviders; accountType?: AccountType }): Promise<InitKYC_T> {
    const res = await app.post(API_ROUTES.kycInit, data)
    return res.data
}

export async function initAccountKYC(data: {
    accountId: string
    provider: KycProviders
    accountType?: AccountType
}): Promise<InitKYC_T> {
    const { accountId, ...payload } = data
    const res = await app.post(insertStringVariables(API_ROUTES.accountsKycInit, accountId), payload)
    return res.data
}

export async function initAccountParticipantKYC(
    accountId: string,
    participantId: string,
    data: { provider: KycProviders; accountType?: AccountType },
): Promise<InitKYC_T> {
    const res = await app.post(
        insertStringVariables(API_ROUTES.accountsParticipantsKycInit, accountId, participantId),
        data,
    )
    return res.data
}

export async function requestKYCStatusUpdate(): Promise<any> {
    const res = await app.put(API_ROUTES.requestStatusUpdate)
    return res.data
}

export async function getUserKYC(): Promise<KYCStatusT> {
    const res = await app.get<KYCStatusT>(API_ROUTES.kyc)
    return res.data
}

export async function getAccountKYC(accountId: string): Promise<KYCStatusT> {
    const res = await app.get<KYCStatusT>(insertStringVariables(API_ROUTES.accountsKyc, accountId))
    return res.data
}
